// extracted by mini-css-extract-plugin
export default {"container":"WQ-z","leftColumn":"XQ-z","rightColumn":"YQ-z","item":"ZQ-z"};